import { render, staticRenderFns } from "./VlTextarea.vue?vue&type=template&id=074d342b&"
import script from "./VlTextarea.vue?vue&type=script&lang=js&"
export * from "./VlTextarea.vue?vue&type=script&lang=js&"
import style0 from "./VlTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports